 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"module-calendar":"module-calendar","module-championship":"module-championship","module-championship-profile-manage~module-myfederation":"module-championship-profile-manage~module-myfederation","module-competition-manage~module-myfederation":"module-competition-manage~module-myfederation","module-myfederation":"module-myfederation","module-championship-profile~module-championship-profile-manage~module-competition-manage~module-comp~4e0d01fe":"module-championship-profile~module-championship-profile-manage~module-competition-manage~module-comp~4e0d01fe","module-championship-profile~module-championship-profile-manage~module-competition-profile":"module-championship-profile~module-championship-profile-manage~module-competition-profile","module-championship-profile":"module-championship-profile","module-championship-profile-manage~module-competition-manage":"module-championship-profile-manage~module-competition-manage","module-championship-profile-manage":"module-championship-profile-manage","module-competition-manage~module-horses-profile~module-member-profile":"module-competition-manage~module-horses-profile~module-member-profile","module-competition-manage":"module-competition-manage","module-competition-profile~module-horses-profile~module-member-profile~module-organisation-profile":"module-competition-profile~module-horses-profile~module-member-profile~module-organisation-profile","module-competition-profile":"module-competition-profile","module-horses-profile":"module-horses-profile","module-member-profile~module-member-save~module-organisation-save":"module-member-profile~module-member-save~module-organisation-save","module-member-profile":"module-member-profile","module-competition-create":"module-competition-create","module-member-save~module-organisation-profile":"module-member-save~module-organisation-profile","module-organisation-profile":"module-organisation-profile","module-finance":"module-finance","module-horses":"module-horses","module-horses-save":"module-horses-save","module-member":"module-member","module-member-save":"module-member-save","module-organisation-save":"module-organisation-save","module-organisation":"module-organisation"}[chunkId]||chunkId) + "." + {"chunk-1116d5b2":"2b21d98b","chunk-1a177ac0":"a2fcd95c","chunk-1b0eb8ab":"57f5d06c","chunk-1b8c7a8f":"c9b0f7f3","chunk-3413375a":"27a3af1c","chunk-94795a2e":"956965cb","chunk-25002e6a":"40bf1572","chunk-253f9995":"e96c857d","chunk-302b7e91":"84024fea","chunk-31d12447":"c463095e","chunk-3bccdb58":"ec364b2f","chunk-6d7477cd":"5c450e86","chunk-6fa59dfb":"b12e0804","chunk-9c13ca22":"44554b76","chunk-b7e06c70":"04f97570","chunk-db007868":"026d9e2e","chunk-e398d036":"5218a940","module-calendar":"9d4d05e9","module-championship":"abe1636d","module-championship-profile-manage~module-myfederation":"82f053af","module-competition-manage~module-myfederation":"d3b1705c","module-myfederation":"c8eccdb8","module-championship-profile~module-championship-profile-manage~module-competition-manage~module-comp~4e0d01fe":"db97b8f9","module-championship-profile~module-championship-profile-manage~module-competition-profile":"87121e8f","module-championship-profile":"9470a273","module-championship-profile-manage~module-competition-manage":"048f444e","module-championship-profile-manage":"cbabd233","module-competition-manage~module-horses-profile~module-member-profile":"f166e2c6","module-competition-manage":"08e75400","module-competition-profile~module-horses-profile~module-member-profile~module-organisation-profile":"69ef2610","module-competition-profile":"ec4a5c32","module-horses-profile":"11627cc7","module-member-profile~module-member-save~module-organisation-save":"53560dbf","module-member-profile":"3bcf1b25","module-competition-create":"2042f3cd","module-member-save~module-organisation-profile":"d74e71b1","module-organisation-profile":"71f46dcb","module-finance":"9fec0f99","module-horses":"c8a27b8b","module-horses-save":"73c325d4","module-member":"030b1bbe","module-member-save":"9e472e8d","module-organisation-save":"5ec745b5","module-organisation":"843fd1e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1b8c7a8f":1,"chunk-9c13ca22":1,"chunk-b7e06c70":1,"module-calendar":1,"module-championship":1,"module-championship-profile-manage~module-myfederation":1,"module-myfederation":1,"module-championship-profile~module-championship-profile-manage~module-competition-manage~module-comp~4e0d01fe":1,"module-championship-profile":1,"module-championship-profile-manage":1,"module-competition-manage":1,"module-competition-profile":1,"module-horses-profile":1,"module-member-profile":1,"module-organisation-profile":1,"module-horses":1,"module-member":1,"module-organisation":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"module-calendar":"module-calendar","module-championship":"module-championship","module-championship-profile-manage~module-myfederation":"module-championship-profile-manage~module-myfederation","module-competition-manage~module-myfederation":"module-competition-manage~module-myfederation","module-myfederation":"module-myfederation","module-championship-profile~module-championship-profile-manage~module-competition-manage~module-comp~4e0d01fe":"module-championship-profile~module-championship-profile-manage~module-competition-manage~module-comp~4e0d01fe","module-championship-profile~module-championship-profile-manage~module-competition-profile":"module-championship-profile~module-championship-profile-manage~module-competition-profile","module-championship-profile":"module-championship-profile","module-championship-profile-manage~module-competition-manage":"module-championship-profile-manage~module-competition-manage","module-championship-profile-manage":"module-championship-profile-manage","module-competition-manage~module-horses-profile~module-member-profile":"module-competition-manage~module-horses-profile~module-member-profile","module-competition-manage":"module-competition-manage","module-competition-profile~module-horses-profile~module-member-profile~module-organisation-profile":"module-competition-profile~module-horses-profile~module-member-profile~module-organisation-profile","module-competition-profile":"module-competition-profile","module-horses-profile":"module-horses-profile","module-member-profile~module-member-save~module-organisation-save":"module-member-profile~module-member-save~module-organisation-save","module-member-profile":"module-member-profile","module-competition-create":"module-competition-create","module-member-save~module-organisation-profile":"module-member-save~module-organisation-profile","module-organisation-profile":"module-organisation-profile","module-finance":"module-finance","module-horses":"module-horses","module-horses-save":"module-horses-save","module-member":"module-member","module-member-save":"module-member-save","module-organisation-save":"module-organisation-save","module-organisation":"module-organisation"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
